import { Box, CircularProgress, Typography } from "@mui/material";
import PageBanner from "../components/application/PageBanner";
import { ImageService } from "../services/image.service";
import { Images } from "../models/assets-files";
import useScreen from "../components/common/UseScreen";
import { BannerTexts, GeneralButtonLabel, ScammersLibraryText } from "../data/texts";
import InputSubmit from "../components/common/InputSubmit";
import { useState } from "react";
import { IdentityTheftCheckerService } from "../services/identity-theft-checker.service";
import { useDispatch } from "react-redux";
import { showSnackbar } from "../store/system.store";

const validateEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  return emailRegex.test(email);
};

const IdentityChecker = () => {
  const { isMobile } = useScreen();
  const dispatch = useDispatch();

  const [email, setEmail] = useState<string>("");
  const [result, setResult] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const isFormValid = validateEmail(email);
  const handleSubmit = async () => {
    try {
      if (!isFormValid) return;

      // reset form state
      setResult("");
      setIsLoading(true);

      const response = await IdentityTheftCheckerService.getHibpData(email);
      setResult(response);
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message || "Something went wrong.";
      dispatch(showSnackbar({ msg: errorMessage, isError: true }));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box>
      <PageBanner
        containerSx={{ padding: isMobile ? "0" : "24px" }}
        imageSrc={ImageService.getLocalImgPath(Images.Folders.BANNERS, Images.Banners.CODE, "png")}
        subtitle={BannerTexts.IDENTITY_THEFT_CHECKER_DESCRIPTION}
        title={BannerTexts.IDENTITY_THEFT_CHECKER}
      >
        <slot name="content">
          <InputSubmit
            disabled={!isFormValid || isLoading}
            handleSubmit={handleSubmit}
            onInput={setEmail}
            button={{ label: GeneralButtonLabel.SEARCH }}
            containerSx={{
              width: "100%",
              height: isMobile ? "unset" : "58px",
              maxWidth: "600px",
              flexDirection: isMobile ? "column" : "row",
            }}
            input={{
              placeholder: ScammersLibraryText.BANNER_EMAIL_PLACEHOLDER,
            }}
          />
        </slot>
      </PageBanner>
      {isLoading && <CircularProgress sx={{ position: "absolute", left: "47%" }} />}
      <Typography sx={{ marginInline: "25px", fontSize: "30px", fontWeight: "500" }}>{result}</Typography>
    </Box>
  );
};

export default IdentityChecker;
